import { useMemo } from "react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import type { AirlineOption } from "../../../types";
import { SearchablePicker, type SearchablePickerOption } from "../../SearchablePicker";

type SingleAirlineSectionProps = {
  airlines: AirlineOption[];
  selectedAirlineId: number | null;
  onAirlineChange: (airlineId: number) => void;
};

export const SingleAirlineSection = ({ airlines, selectedAirlineId, onAirlineChange }: SingleAirlineSectionProps) => {
  const i18n = useI18n();
  const options: SearchablePickerOption[] = useMemo(
    () => airlines.map((airline) => ({ id: String(airline.id), label: airline.name, sublabel: airline.code })),
    [airlines]
  );

  return (
    <SearchablePicker
      layout="fluid"
      label={i18n.trans(t("flights_airline_portal_add_user_airline_selector_label"))}
      placeholder={i18n.trans(t("flights_airline_portal_add_user_airline_selector_placeholder"))}
      searchPlaceholder={i18n.trans(t("flights_airline_portal_add_user_airline_selector_search"))}
      options={options}
      sortSelectedFirst
      value={selectedAirlineId === null ? null : String(selectedAirlineId)}
      onChange={(id) => onAirlineChange(Number(id))}
    />
  );
};
